import {UnitsType} from "@pg-design/range-module";

import {CalculatorValueType} from "../../credit_calculator/types/CalculatorValueType";
import {ICalculatorOptions} from "../../credit_calculator/types/ICalculatorOptions";
import {RangeOptionNameType} from "../../credit_calculator/types/RangeOptionNameType";

export const PropertyCreditCalculatorRangesOptions: ICalculatorOptions[] = [
    {
        title: "Wkład własny",
        name: RangeOptionNameType.CONTRIBUTION,
        desc: "Większość banków wymaga wkładu własnego na poziomie 20% ceny nieruchomości",
        values: {
            lower: 10,
            upper: 90,
            init: 20
        },
        uniteType: UnitsType.PERCENTS,
        step: 5,
        valueType: CalculatorValueType.CONTRIBUTION
    },
    {
        title: "Okres kredytowania",
        name: RangeOptionNameType.PERIOD,
        desc: "Rata miesięczna jest zależna od długości okresu kredytowania",
        values: {
            lower: 5,
            upper: 35,
            init: 30
        },
        step: 5,
        uniteType: UnitsType.YEARS,
        valueType: CalculatorValueType.PERIOD
    }
];
import {UnitsType} from "@pg-design/range-module";

import {CalculatorValueType} from "../../credit_calculator/types/CalculatorValueType";
import {ICalculatorOptions} from "../../credit_calculator/types/ICalculatorOptions";
import {RangeOptionNameType} from "../../credit_calculator/types/RangeOptionNameType";

export const PropertyCreditCalculatorRangesOptions: ICalculatorOptions[] = [
    {
        title: "Wkład własny",
        name: RangeOptionNameType.CONTRIBUTION,
        desc: "Większość banków wymaga wkładu własnego na poziomie 20% ceny nieruchomości",
        values: {
            lower: 10,
            upper: 90,
            init: 20
        },
        uniteType: UnitsType.PERCENTS,
        step: 5,
        valueType: CalculatorValueType.CONTRIBUTION
    },
    {
        title: "Okres kredytowania",
        name: RangeOptionNameType.PERIOD,
        desc: "Rata miesięczna jest zależna od długości okresu kredytowania",
        values: {
            lower: 5,
            upper: 35,
            init: 30
        },
        step: 5,
        uniteType: UnitsType.YEARS,
        valueType: CalculatorValueType.PERIOD
    }
];
